// PATH: src/pages/SocialMedia.jsx
// VERSION: 2.4 — WhatsApp desplegable, teléfono alineado debajo

import React from 'react';
import {
  Box,
  Heading,
  Text,
  Link,
  SimpleGrid,
  Container,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorModeValue,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { FaFacebook, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';
import links from '../data/social_links.json';
import contactData from '../data/contact.json';

const iconMap = {
  Facebook: FaFacebook,
  Instagram: FaInstagram,
  YouTube: FaYoutube,
  WhatsApp: FaWhatsapp,
};

const buildWhatsAppLink = (phone) => {
  // Convierte "+504 3340-2454" -> "50433402454"
  const digits = (phone || '').replace(/\D/g, '');
  return `https://wa.me/${digits}`;
};

export default function SocialMedia() {
  const contacts = contactData.contacts || [];

  return (
    <>
      <Container maxW="container.xl" py={{ base: 4, md: 8 }}>
        <Heading textAlign="center" mb={6} color="text.default" size="lg">
          Redes Sociales
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} spacing={8}>
          {links.items.map((media) => {
            const Icon = iconMap[media.name] || FaFacebook;
            const isWhatsApp = media.name === 'WhatsApp';
            const hasContacts = contacts.length > 0;

            const hoverProps = isWhatsApp
              ? { boxShadow: 'md' } // sin translateY para evitar parpadeo en el menú
              : { transform: 'translateY(-4px)', boxShadow: 'md' };

            return (
              <Box
                key={media.name}
                borderWidth="1px"
                borderRadius="xl"
                overflow="hidden"
                bg="bg.card"
                boxShadow="sm"
                transition="all .25s ease"
                _hover={hoverProps}
                textAlign="center"
                p={6}
              >
                <Icon size="48px" color={media.color} />
                <Heading size="md" mt={4} color="text.default">
                  {media.name}
                </Heading>

                {isWhatsApp ? (
                  <>
                    <Text mt={2} color="text.muted">
                      Escríbenos por WhatsApp eligiendo un contacto:
                    </Text>

                    {hasContacts ? (
                      <Menu isLazy>
                        <MenuButton
                          as={Button}
                          mt={4}
                          rightIcon={<ChevronDownIcon />}
                          width={{ base: '100%', sm: 'auto' }}
                          fontWeight="semibold"
                          leftIcon={<FaWhatsapp />}
                        >
                          Seleccionar contacto
                        </MenuButton>
                        <MenuList maxW="90vw" fontSize="sm" zIndex={10}>
                          {contacts.map((c) => (
                            <MenuItem
                              key={c.name}
                              as="a"
                              href={buildWhatsAppLink(c.phone)}
                              target="_blank"
                              rel="noopener noreferrer"
                              whiteSpace="normal"
                              lineHeight="short"
                              py={2}
                              alignItems="flex-start"
                            >
                              <Box textAlign="left">
                                <Text fontWeight="bold">{c.name}</Text>
                                <Text>{c.phone}</Text>
                              </Box>
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Menu>
                    ) : (
                      <Text mt={3} fontSize="sm" color="text.muted">
                        Próximamente añadiremos contactos de WhatsApp.
                      </Text>
                    )}

                    {media.link && media.link !== '#' && (
                      <Link
                        href={media.link}
                        isExternal
                        mt={4}
                        display="block"
                        color="blue.600"
                        fontWeight="semibold"
                        fontSize="sm"
                      >
                        Ir al grupo general de WhatsApp
                      </Link>
                    )}
                  </>
                ) : (
                  <>
                    <Text mt={2} color="text.muted">
                      Síguenos en {media.name} para más información.
                    </Text>
                    <Link
                      href={media.link}
                      isExternal
                      mt={4}
                      display="block"
                      color="blue.600"
                      fontWeight="bold"
                    >
                      Sala Evangélica Barrio Lempira
                    </Link>
                  </>
                )}
              </Box>
            );
          })}
        </SimpleGrid>
      </Container>
    </>
  );
}
